import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  fetchDataError,
  fetchDataSuccess,
  submitMailboxUpdateError,
  submitMailboxUpdateSuccess,
} from './actions'
import { FETCH_DATA, SUBMIT_MAILBOX_UPDATE } from './constants'

const fetchDataEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      FETCH_DATA.INITIATE,
      SUBMIT_MAILBOX_UPDATE.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    })
    .mergeMap(() =>
      api.dashboard
        .getMailboxesData(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => fetchDataSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(fetchDataError, error)))
        .takeUntil(action$.ofType(FETCH_DATA.CANCEL))
    )

const submitMailboxUpdateEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(SUBMIT_MAILBOX_UPDATE.INITIATE).mergeMap(() =>
    api.dashboard
      .updateMailboxesData(
        store.getState().partnerOptions.selectedCompany?.value,
        store.getState().dashboard.home.mailboxesStatus.mailboxesToAdd
      )
      .mergeMap((response) =>
        Observable.of(
          submitMailboxUpdateSuccess(response),
          addToast({
            message: 'The email was successfully sent',
          })
        )
      )
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(submitMailboxUpdateError, error),
          addToast({
            message: error.response?.message || error?.response,
            type: 'error',
          })
        )
      )
      .takeUntil(action$.ofType(SUBMIT_MAILBOX_UPDATE.CANCEL))
  )

export default combineEpics(fetchDataEpic, submitMailboxUpdateEpic)
